import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

// const EVENTS = [
//     "mousemove",
//     "mousedown",
//     "mouseup",
//     "click",
//     "keydown",
//     "keyup",
//     "scroll",
//     "wheel",
//     "touchstart",
//     "touchmove",
//     "pointerdown",
//     "pointermove",
//     "focus",
//     "visibilitychange",
// ];

const EVENTS = ["mousemove", "keydown", "mousedown", "touchstart", "click"];

const ActivityTracker = ({ session, loginStatus, onCountsChange }) => {
    const countsRef = useRef({});

    const canTrack = () => {
        return (
            (session === "attendance" || session === "overtime") &&
            loginStatus === "already_logged_in"
        );
    };

    const handleEvent = (e) => {
        if (!canTrack()) return;

        const type = e.type;
        countsRef.current[type] = (countsRef.current[type] || 0) + 1;

        // parent ko latest counts de do (DashboardNavbar)
        onCountsChange({ ...countsRef.current });
        console.log("Activity counts:", countsRef.current);
    };

    useEffect(() => {
        EVENTS.forEach((ev) => window.addEventListener(ev, handleEvent));

        return () => {
            EVENTS.forEach((ev) => window.removeEventListener(ev, handleEvent));
        };
    }, [session, loginStatus]);

    return null;
};

ActivityTracker.propTypes = {
    session: PropTypes.string,
    loginStatus: PropTypes.string,
    onCountsChange: PropTypes.func.isRequired,
};

export default ActivityTracker;
